import React, { useState } from "react";
import ServiceManagerWs from "./ServiceManager_ws";
import ServiceManagerOld from "./ServiceManager_old";
import styles from '../styles/ServiceManager.module.css';

export default function ServiceManager() {
  const [mode, setMode] = useState("ws");

  return (
    <div className={styles.super_container}>
      <div className={styles.modeTabs}>
        <button
          className={`${styles.tabButton} ${mode === "ws" ? styles.tabButtonActive : ""}`}
          onClick={() => setMode("ws")}
        >
          WS режим
        </button>
        <button
          className={`${styles.tabButton} ${mode === "classic" ? styles.tabButtonActive : ""}`}
          onClick={() => setMode("classic")}
        >
          Классический режим
        </button>
      </div>
      {mode === "ws" ? <ServiceManagerWs /> : <ServiceManagerOld />}
    </div>
  );
}
